import GlobalFooter from '@/components/shared/global-footer/GlobalFooter.vue';
import GlobalHeader from '@/components/shared/global-header/GlobalHeader.vue';
import ScrollToTopButton from '@/components/shared/scroll-to-top-button/ScrollToTopButton.vue';
import router from '@/routers';
import {
  applyInitialAuthPresentationFromDom,
  ensureInitialAuthResolved,
  markAuthShellPartReady,
  markAuthShellPending,
  shouldUseFastInitialAuthPresentation,
} from '@/utils/authMe';
import 'bootstrap/dist/js/bootstrap.bundle';
import { createApp } from 'vue';
import '../controllers';

/**
 * @param {string} selector
 * @param {import('vue').Component} component
 * @param {{ useRouter?: boolean }} [options]
 */
const mountIfExists = (selector, component, options = {}) => {
  const el = document.querySelector(selector);
  if (!el) return;
  const { loggedIn, userName } = /** @type {HTMLElement} */ (el).dataset || {};
  const props = {
    isLoggedIn: loggedIn === 'true',
    userName,
  };
  const app = createApp(component, props);
  if (options.useRouter) {
    app.use(router);
  }
  app.mount(el);
};

const mountGlobalShell = async () => {
  const headerEl = document.querySelector('#global-header-vue');
  const hasAppShell = !!headerEl && !!document.querySelector('#app');
  const fastInitialAuthPresentation = hasAppShell && shouldUseFastInitialAuthPresentation();

  if (fastInitialAuthPresentation) {
    const authenticated = applyInitialAuthPresentationFromDom();
    /** @type {HTMLElement} */ (headerEl).dataset.loggedIn = String(authenticated);
  } else if (hasAppShell) {
    markAuthShellPending();
    const authenticated = await ensureInitialAuthResolved();
    /** @type {HTMLElement} */ (headerEl).dataset.loggedIn = String(authenticated);
  }

  mountIfExists('#global-header-vue', GlobalHeader, { useRouter: true });
  mountIfExists('#global-footer-vue', GlobalFooter);
  mountIfExists('#scroll-to-top-button-vue', ScrollToTopButton);

  if (hasAppShell && !fastInitialAuthPresentation) {
    markAuthShellPartReady('header');
  }
};

const runWhenIdle = callback => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 2000 });
    return;
  }
  window.setTimeout(callback, 1000);
};

const loadTopDeferredEntrypoints = () => {
  if (window.location.pathname !== '/') return;

  runWhenIdle(() => {
    if (document.querySelector('#footer-mega')) {
      void import('./footer_mega');
    }
    if (document.querySelector('#registration-modal-container')) {
      void import('./dashboard_modal');
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    void mountGlobalShell().then(loadTopDeferredEntrypoints);
  });
} else {
  void mountGlobalShell().then(loadTopDeferredEntrypoints);
}
